import { Component } from '@angular/core';

@Component({
  selector: 'app-legal-notice',
  templateUrl: './legal-notice.component.html',
  styleUrls: ['./legal-notice.component.scss']
})
export class LegalNoticeComponent {
  siteOwner = 'Alessandro Bompadre';
  lastUpdated = '29 marzo 2026';
}
